/**
 * You are encouraged to use entry point export in src
 * However, at the time of development, this was mounted in JWM onboarding which had no relay environment
 * Hence we have this rll export as an alternative way to chunk the spotlight
 */
import React from 'react';
import { lazyAfterPaint } from 'react-loosely-lazy';
import { ErrorBoundary } from '@atlassian/jira-error-boundary';
import Placeholder from '@atlassian/jira-placeholder';
import { ERROR_BOUNDARY_ID_X2C_TOUR_NUDGE, APP_IDENTIFIER } from '../common/constants';
import type X2COnboardingType from './main';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const X2COnboarding = lazyAfterPaint<typeof X2COnboardingType>(
	() => import(/* webpackChunkName: "async-x2c-onboarding" */ './main'),
	{ ssr: false },
);

const X2COnboardingAsync = () => (
	<ErrorBoundary id={ERROR_BOUNDARY_ID_X2C_TOUR_NUDGE} packageName={APP_IDENTIFIER}>
		<Placeholder name="x2c-onboarding" fallback={null}>
			<X2COnboarding />
		</Placeholder>
	</ErrorBoundary>
);

export default X2COnboardingAsync;
